<template>
  <b-modal id="modal-add-edit-mesa-votacion" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" v-model="mostrarModal" dialog-class="modal-dialog-scrollable" v-if="mostrarModal" @close="handleModalClose">
    <template slot="modal-title">
      <div>
        <span class="font-weight-light"><i class="la la-table"></i> {{ mesaVotacion.localVotacionMesaId ? "Editar" : "Agregar" }} Mesa de Votación</span>
      </div>
    </template>
    <b-form id="frm-add-edit-mesa-votacion">
      <div class="row pt-1">
        <div class="col-md-6">
          <label class="font-weight-bold">Región</label>
          <select class="form-control" v-model="mesaVotacion.regionId" @change="onRegionChange">
            <option :value="null">- Seleccionar -</option>
            <option v-for="region in regiones" :value="region.regionId" :key="region.regionId">{{ region.nombre }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="font-weight-bold">Sub región</label>
          <select class="form-control" v-model="mesaVotacion.subRegionId" @change="onSubRegionChange">
            <option :value="null">- Seleccionar -</option>
            <option v-for="subRegion in subRegiones" :value="subRegion.subRegionId" :key="subRegion.subRegionId">{{ subRegion.nombre }}</option>
          </select>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Local de votación</label>
          <treeselect :multiple="false" :options="localesVotacionOptions" placeholder="Buscar local de votación..." v-model="mesaVotacion.localVotacionId" @input="onLocalVotacionInput"></treeselect>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">N° de Mesa</label>
          <b-form-input v-model="mesaVotacion.mesa" required placeholder="Número de mesa"></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Electores</label>
          <b-form-input v-model="mesaVotacion.electores" type="number" placeholder="Cantidad de electores"></b-form-input>
        </div>
      </div>
    </b-form>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="handleModalClose()"><i class="fa fa-ban"></i> Cancelar</button>
      <button type="button" class="btn btn-primary font-weight-bold" @click.prevent="doSave()"><i class="fa fa-save"></i> Guardar</button>
    </template>
  </b-modal>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "add-edit-mesa-votacion",
  props: {
    value: { type: Boolean, required: true },
    mesaVotacionId: { type: Number },
  },
  data: () => ({
    mostrarModal: true,
    regiones: [],
    subRegiones: [],
    localesVotacionItems: [],
    localesVotacionOptions: [],
    mesaVotacion: {
      localVotacionMesaId: null,
      localVotacionId: null,
      mesa: "",
      electores: null,
      usuarioAsignadoId: 0,
      regionId: null,
      subRegionId: null,
    },
  }),
  methods: {
    handleModalClose(event) {
      if (event) event.preventDefault();
      this.mostrarModal = false;
    },
    onRegionChange() {
      this.mesaVotacion.subRegionId = null;
      this.subRegiones = [];
      if (this.mesaVotacion.regionId) {
        this.fetchSubRegiones(this.mesaVotacion.regionId);
      }
      this.fetchLocalesVotacion();
    },
    onSubRegionChange() {
      this.fetchLocalesVotacion();
    },
    onLocalVotacionInput(localVotacionId) {
      if (!localVotacionId || !this.localesVotacionItems.length) return;
      var item = this.localesVotacionItems.find((x) => x.localVotacionId === localVotacionId);
      if (item) {
        this.mesaVotacion.regionId = item.regionId;
        this.mesaVotacion.subRegionId = item.subRegionId;
        if (item.regionId) {
          this.fetchSubRegiones(item.regionId);
        }
      }
    },
    async doSave() {
      if (!(await this.sweetConfirm("¿Desea guardar los datos?"))) return;
      if (!this.mesaVotacion.localVotacionId) return this.sweetAlert("Debe seleccionar el local de votación.");
      if (!this.isFormValid("frm-add-edit-mesa-votacion")) return this.sweetAlert("Hay campos con valores incorrectos. Revise los datos ingresados.");

      var model = { ...this.mesaVotacion };
      await this.$http.post(this.apiRoute("Location", "AddEditMesaVotacion"), model).then(
        function(response) {
          if (!this.procesarRespuestaErrorDefecto(response)) {
            this.sweetAlert(response.body.message, "success");
            this.$emit("onSave", { localVotacionMesaId: response.body.data.localVotacionMesaId });
            this.mostrarModal = false;
          }
        },
        this.mostrarMensajeExcepcionVueResource
      );
    },
    fetchMesaVotacion(mesaVotacionId) {
      if (mesaVotacionId) {
        this.$http.get(this.apiRoute("Location", "GetMesaVotacionById"), { params: { LocalVotacionMesaId: mesaVotacionId } }).then(
          function(response) {
            var d = response.body.data || {};
            this.mesaVotacion = {
              localVotacionMesaId: d.localVotacionMesaId,
              localVotacionId: d.localVotacionId,
              mesa: d.mesa,
              electores: d.electores,
              usuarioAsignadoId: d.usuarioAsignadoId != null ? d.usuarioAsignadoId : 0,
              regionId: d.regionId != null ? d.regionId : null,
              subRegionId: d.subRegionId != null ? d.subRegionId : null,
            };
            if (this.mesaVotacion.regionId) {
              this.$http
                .get(this.apiRoute("Region", "ListSubRegionesPorRegion"), {
                  params: { RegionId: this.mesaVotacion.regionId },
                })
                .then(function(r2) {
                  this.subRegiones = r2.body.data.items || [];
                  this.fetchLocalesVotacion();
                }, this.mostrarMensajeExcepcionVueResource);
            } else {
              this.fetchLocalesVotacion();
            }
          },
          this.mostrarMensajeExcepcionVueResource
        );
      } else {
        this.mesaVotacion = {
          localVotacionMesaId: null,
          localVotacionId: null,
          mesa: "",
          electores: null,
          usuarioAsignadoId: 0,
          regionId: null,
          subRegionId: null,
        };
        this.subRegiones = [];
        this.fetchLocalesVotacion();
      }
    },
    fetchRegiones() {
      var modelRegion = {};
      this.$http.post(this.apiRoute("Region", "ListRegiones"), modelRegion).then(function(response) {
        this.regiones = response.body.data.items;
      }, this.mostrarMensajeExcepcionVueResource);
    },
    fetchSubRegiones(regionId) {
      if (!regionId) {
        this.subRegiones = [];
        return;
      }
      this.$http
        .get(this.apiRoute("Region", "ListSubRegionesPorRegion"), {
          params: { RegionId: regionId },
        })
        .then(function(response) {
          this.subRegiones = response.body.data.items || [];
        }, this.mostrarMensajeExcepcionVueResource);
    },
    fetchLocalesVotacion() {
      var model = {
        pagination: { paginate: false },
        regionId: this.mesaVotacion.regionId || null,
        subRegionId: this.mesaVotacion.subRegionId || null,
      };
      this.$http.post(this.apiRoute("Location", "ListLocalesVotacion"), model).then(
        function(response) {
          var items = response.body.data.items || [];
          this.localesVotacionItems = items;
          this.localesVotacionOptions = items.map(function(x) {
            var label = [x.codigo, x.nombre, x.direccion].filter(Boolean).join(" - ");
            return { id: x.localVotacionId, label: label || "Sin descripción" };
          });
          if (this.mesaVotacion.localVotacionId && !items.some((x) => x.localVotacionId === this.mesaVotacion.localVotacionId)) {
            this.mesaVotacion.localVotacionId = null;
          }
        },
        this.mostrarMensajeExcepcionVueResource
      );
    },
  },
  watch: {
    mostrarModal(newValue) {
      this.$emit("input", newValue);
    },
  },
  mounted() {
    this.mostrarModal = this.value;
    this.mesaVotacion.localVotacionMesaId = this.mesaVotacionId;
    this.initParsley();
    this.fetchRegiones();
    this.fetchMesaVotacion(this.mesaVotacionId);
  },
};
</script>
